import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { dashboardRoute } from "../routes/reactRoutes";
import verifyToken from "./CheckToken";

export const PublicRoute = ({ children }) => {
  const location = useLocation();
  const currentUser = useSelector(
    (state) => state.authenticationValues.currentUser
  );
  
  // Check if user is authenticated (has token and user data)
  const isAuthenticated = verifyToken() && currentUser?.firstName;
  
  // If authenticated, redirect to dashboard (or previous location if available)
  if (isAuthenticated) {
    const prevLocation = localStorage.getItem("prevLocation");
    const redirectTo = prevLocation && prevLocation !== "/login" 
      ? prevLocation 
      : dashboardRoute;
    
    return <Navigate to={redirectTo} replace />;
  }
  
  // If not authenticated, allow access to public route
  return children;
};